import {Cells} from './cells';

export const CellsContainer = Cells;
